import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { FormattedMessage } from 'react-intl';

import gfm from 'remark-gfm';
import directive from 'remark-directive';
import visit from 'unist-util-visit';

function directiveHandler() {
  function transform(tree) {
    visit(tree, ['containerDirective'], () => {});
  }

  return transform;
}

const DefaultRenderer = () => (
  <span className="text-danger">
    <FormattedMessage
      id="markdown-invalid-directive"
      defaultMessage="Virheellinen viittaus"
    />
  </span>
);

const Renderer = props => {
  switch (props.name) {
    case 'youtube': {
      const attributes = Object.keys(props.attributes);
      if (attributes.length !== 1) {
        return (
          <span className="text-danger">
            <FormattedMessage
              id="markdown-invalid-directive-youtube"
              defaultMessage="Virheellinen YouTube-viittaus"
            />
          </span>
        );
      }

      const [shortcode] = attributes;

      return (
        <div className="embed-responsive embed-responsive-16by9">
          <iframe
            title="YouTube embed"
            className="embed-responsive-item"
            src={`https://www.youtube.com/embed/${shortcode}?feature=oembed`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      );
    }

    default:
      return DefaultRenderer();
  }
};

const Markdown = ({ source, ...props }) => {
  return (
    <ReactMarkdown
      plugins={[gfm, directive, directiveHandler]}
      renderers={{
        textDirective: DefaultRenderer,
        leafDirective: DefaultRenderer,
        containerDirective: Renderer,
      }}
      {...props}
    >
      {source}
    </ReactMarkdown>
  );
};

Markdown.propTypes = {
  source: PropTypes.string.isRequired,
};

export default Markdown;
